import React from 'react';
import MarketplacePracticeLocation from '../MarketplacePracticeLocation/MarketplacePracticeLocation';
import { EntityLocationInfo } from '../../../../slices/profiles-data-slice/models/entity-location-info';
import './MarketplacePracticeLocationsTable.scss';
import { useFormikContext, getIn } from 'formik';
import { PracticeProfileImage } from '../../../../slices/profiles-data-slice/models/practice-profile-image';

interface MarketplacePracticeLocationsTableProps {
    locations: EntityLocationInfo[];
    fieldPrefix: string;
    setFormFieldValue(name: string, value: any): void;
    removeLocation(locationIndex: number): void;
    isEditable?: boolean;
    canEditRatings?: boolean;
    timelineId?: number;
    practiceId?: string;
    profileId?: string;
    practiceUploads?: PracticeProfileImage[];
    showImagesFromLocationId?: string;
    onShowImagesFromChange?(locationId: string): void;
}

export const MarketplacePracticeLocationsTable: React.FC<
    MarketplacePracticeLocationsTableProps
> = (props: MarketplacePracticeLocationsTableProps) => {
    const { isEditable = true } = props;
    const { values } = useFormikContext();

    // Radio only when there is a choice between locations.
    const showImagesFromColumn =
        props.locations.length > 1 && !!props.onShowImagesFromChange;

    const showReadonlyRatings = () => {
        if (props.canEditRatings) {
            return false;
        }
        const locations = getIn(
            values,
            `${props.fieldPrefix}`
        ) as EntityLocationInfo[];
        return !!locations?.some(
            (location) =>
                location.ratings?.google != null ||
                location.ratings?.facebook != null ||
                location.ratings?.yelp != null
        );
    };

    return (
        <div className="practice-locations-cards">
            {props.locations.map((location, index) => (
                <MarketplacePracticeLocation
                    key={location.id}
                    location={location}
                    index={index}
                    fieldPrefix={props.fieldPrefix}
                    setFormFieldValue={props.setFormFieldValue}
                    removeLocation={props.removeLocation}
                    isRemovalAllowed={props.locations.length > 1}
                    isEditable={isEditable}
                    canEditRatings={props.canEditRatings}
                    showReadonlyRatings={showReadonlyRatings()}
                    timelineId={props.timelineId}
                    practiceId={props.practiceId}
                    profileId={props.profileId}
                    practiceUploads={props.practiceUploads}
                    showImagesFromColumn={showImagesFromColumn}
                    showImagesFromLocationId={props.showImagesFromLocationId}
                    onShowImagesFromChange={props.onShowImagesFromChange}
                />
            ))}
        </div>
    );
};

export default MarketplacePracticeLocationsTable;
